import type { ChainLpcLppSupplierPropertyGroup } from '~/types/services/priceParrot';

/** LPC bookings ÷ LPP bookings, or null when there are no LPP bookings to divide by. */
export function computeRatio(lpcBookings: number, lppBookings: number): number | null {
  return lppBookings > 0 ? lpcBookings / lppBookings : null;
}

/** LPC bookings ÷ total LPP bookings for this property. */
export function lpcToLppRatio(group: ChainLpcLppSupplierPropertyGroup): number | null {
  const lpcBookings = group.rows.find((r) => r.channel === 'LPC')?.bookings_count ?? 0;
  const lppBookings = group.rows.filter((r) => r.channel === 'LPP').reduce((sum, r) => sum + r.bookings_count, 0);
  return computeRatio(lpcBookings, lppBookings);
}
